var Ae = Object.defineProperty, qe = Object.defineProperties;
var Fe = Object.getOwnPropertyDescriptors;
var z = Object.getOwnPropertySymbols;
var Pe = Object.prototype.hasOwnProperty, Le = Object.prototype.propertyIsEnumerable;
var W = (t, i, s) => i in t ? Ae(t, i, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[i] = s, O = (t, i) => {
  for (var s in i || (i = {}))
    Pe.call(i, s) && W(t, s, i[s]);
  if (z)
    for (var s of z(i))
      Le.call(i, s) && W(t, s, i[s]);
  return t;
}, q = (t, i) => qe(t, Fe(i));
var o = (t, i, s) => new Promise((y, _) => {
  var h = (d) => {
    try {
      r(s.next(d));
    } catch (T) {
      _(T);
    }
  }, l = (d) => {
    try {
      r(s.throw(d));
    } catch (T) {
      _(T);
    }
  }, r = (d) => d.done ? y(d.value) : Promise.resolve(d.value).then(h, l);
  r((s = s.apply(t, i)).next());
});
import { av as ne, aA as be, aB as xe, r as u, a as c, m as V, ar as G } from "./define-element-XpjsV6s1.js";
import { M as Ue } from "./constants-S7QMI5p0.js";
import { i as p, t as J } from "./utils-CMsllPx8.js";
import { u as $e } from "./use-user-CwEHAZOt.js";
const Z = "offset-session-id";
function ie() {
  const t = ne();
  return t === "cart" ? Z : `${Z}-${t}`;
}
function se() {
  try {
    const t = window.localStorage.getItem(ie());
    return t ? JSON.parse(t) : null;
  } catch (t) {
    return null;
  }
}
function De(t) {
  try {
    window.localStorage.setItem(ie(), JSON.stringify(t));
  } catch (i) {
  }
}
function re() {
  return be;
}
function Ne(t) {
  return o(this, null, function* () {
    if (!se())
      try {
        const s = yield (yield fetch(`${re()}cart/session`, {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: { "Content-Type": "application/json", "X-API-Key": t },
          body: JSON.stringify({ type: ne() })
        })).json();
        s && De(s);
      } catch (i) {
      }
  });
}
let H = null;
const Qe = "offset:legacy-login", Me = "offset:legacy-logout";
let j = null;
function Re(t = {}) {
  var _;
  if (H)
    return;
  const i = (_ = window.OFFSET) == null ? void 0 : _.apiKey;
  if (!i)
    return;
  const s = t.usernameSelector || '[name="auth[username]"]', y = t.passwordSelector || '[name="auth[password]"]';
  Ne(i), H = (h) => {
    const l = h.target;
    if (!(l instanceof HTMLFormElement))
      return;
    const r = l.querySelector(s), d = l.querySelector(y);
    if (!r || !d)
      return;
    const T = se();
    if (T)
      try {
        fetch(`${re()}cart/auth`, {
          method: "POST",
          mode: "cors",
          credentials: "include",
          keepalive: !0,
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": i,
            "X-Session-Id": T
          },
          body: JSON.stringify({
            username: r.value,
            password: d.value
          })
        }).catch(() => {
        });
      } catch (Y) {
      }
  }, document.addEventListener("submit", H, !0), j = (h) => {
    var d;
    const l = (d = h.detail) == null ? void 0 : d.authtoken;
    xe(), (l ? u("cart/auth", {
      method: "POST",
      body: JSON.stringify({ authtoken: l })
    }).catch(() => {
    }) : Promise.resolve()).then(() => {
      document.dispatchEvent(new CustomEvent("cantina:login"));
    });
  }, document.addEventListener(Qe, j), document.addEventListener(Me, j);
}
const A = {};
var oe = /* @__PURE__ */ ((t) => (t[t.showSideCart = 0] = "showSideCart", t[t.addToCart = 1] = "addToCart", t))(oe || {});
function Ge(t, i) {
  A[t] || (A[t] = []), A[t].push(i);
}
function ee(t, ...i) {
  return A[t] ? !Array.isArray(A[t]) || A[t].length === 0 ? !1 : (A[t].forEach((s) => s(...i)), !0) : !1;
}
const Je = window.OFFSET || {}, F = O({
  shopUrl: "/shop",
  cartUrl: "/cart",
  checkoutUrl: "/checkout",
  productDetailsUrl: null,
  showSideCart() {
    return ee(0, ...arguments);
  },
  addToCart() {
    ee(1, ...arguments);
  },
  syncLegacyLogin: Re
}, Je);
window.OFFSET = F;
const ue = 0.29, te = 15e3;
function ae(t, i) {
  return new Promise((s, y) => {
    const _ = setTimeout(() => {
      y(new Error("Request timed out"));
    }, i);
    t.then(
      (h) => {
        clearTimeout(_), s(h);
      },
      (h) => {
        clearTimeout(_), y(h);
      }
    );
  });
}
const w = c({
  items: [],
  config: {
    promo_code: "",
    address_id: "",
    payment_id: "",
    ship_method_id: "",
    requested_ship_date: "",
    allowed_methods: "",
    ship_method_address_lock: "0"
  },
  total: 0,
  discount: 0,
  shipping: 0,
  tax: 0,
  co_retail_delivery_fee: ue,
  ca_redemption_value: 0,
  shipment: {
    address: {
      state: ""
    }
  }
}), B = c(!1), L = c({}), b = c({}), v = c(!1);
let x = null;
const Q = c(0), K = c(!1), He = 400;
let D = null;
function ce() {
  D && (clearTimeout(D), D = null);
}
function je() {
  ce(), D = setTimeout(() => {
    D = null, Q.value <= 0 && (K.value = !1);
  }, He);
}
const U = c(!1), X = c(!1), M = c(null), $ = c(null), N = {};
function C(t = {}) {
  return M.value ? q(O({}, t), { sessionId: M.value }) : t;
}
function ke(t) {
  M.value = t;
}
const ze = V(() => !p(M.value));
function We() {
  const { isValidUser: t } = $e(), i = c([]), s = c(!1), y = c(!1), _ = c(!1), h = c(!1), l = c([]);
  function r() {
    return o(this, null, function* () {
      w.value = ve(yield u("cart", C()));
    });
  }
  function d() {
    return o(this, null, function* () {
      B.value = !0;
      try {
        yield r();
      } catch (e) {
        G(e, { component: "use-cart.ts:loadCart" });
      } finally {
        B.value = !1;
      }
    });
  }
  function T(S) {
    return o(this, arguments, function* (e, n = 1, a = {}) {
      var E, I;
      Q.value++, ce(), K.value = !0, $.value = null, p(a.maxPurchaseQuantity) || (N[e] = a.maxPurchaseQuantity), a.showSideCart !== !1 && F.showSideCart();
      try {
        const g = (E = w.value.items) == null ? void 0 : E.find((m) => m.sku === e), P = g ? parseInt(g.quantity, 10) : 0;
        yield u(`addtocart/${e}/${n}`), yield r();
        const f = (I = w.value.items) == null ? void 0 : I.find((m) => m.sku === e);
        if (f && parseInt(f.quantity, 10) < P + n) {
          const Oe = p(a.maxPurchaseQuantity) ? f.max_purchase_quantity : a.maxPurchaseQuantity;
          $.value = {
            sku: e,
            name: f.name,
            max: Oe
          };
        }
        J("AddToCart", {
          currency: "USD",
          value: f ? parseFloat(f.price) * n : void 0,
          items: [
            {
              id: e,
              name: f == null ? void 0 : f.name,
              quantity: n
            }
          ]
        });
      } finally {
        Q.value--, Q.value <= 0 && je();
      }
    });
  }
  function Y(e) {
    return o(this, null, function* () {
      var a, S;
      L.value = q(O({}, L.value), {
        [e]: !0
      }), F.showSideCart();
      const n = (a = w.value.items) == null ? void 0 : a.find((E) => E.sku === e);
      yield u(`removefromcart/${e}`), J("RemoveFromCart", {
        currency: "USD",
        value: n ? parseFloat(n.price) : void 0,
        items: [
          {
            id: e,
            name: n == null ? void 0 : n.name,
            quantity: (S = n == null ? void 0 : n.quantity) != null ? S : 1
          }
        ]
      }), yield r(), L.value = q(O({}, L.value), {
        [e]: !1
      });
    });
  }
  function le() {
    return o(this, null, function* () {
      v.value = !0, yield u("cart", {
        method: "DELETE"
      }), yield r(), v.value = !1;
    });
  }
  function de(S, E) {
    return o(this, arguments, function* (e, n, a = {}) {
      var P, f;
      v.value = !0, $.value = null, b.value = q(O({}, b.value), {
        [e]: !0
      }), a.showSideCart !== !1 && F.showSideCart();
      const I = (P = w.value.items) == null ? void 0 : P.find((m) => m.sku === e);
      yield u(`cart/items/${e}/${n}`, {
        method: "PUT"
      }), J("AddToCart", {
        currency: "USD",
        value: I ? parseFloat(I.price) * n : void 0,
        items: [
          {
            id: e,
            name: I == null ? void 0 : I.name,
            quantity: n
          }
        ]
      }), yield r();
      const g = (f = w.value.items) == null ? void 0 : f.find((m) => m.sku === e);
      if (g) {
        const m = parseInt(g.quantity, 10);
        m < n && (N[e] = m, g.max_purchase_quantity = m, $.value = {
          sku: e,
          name: g.name,
          max: m
        });
      }
      v.value = !1, b.value = q(O({}, b.value), {
        [e]: !1
      });
    });
  }
  function fe(e) {
    return o(this, null, function* () {
      v.value = !0, _.value = !0, yield u(`cart/address/${e}/select`, C()), yield r(), v.value = !1, _.value = !1;
    });
  }
  function pe(e) {
    return o(this, null, function* () {
      v.value = !0, yield u(`cart/shipping_method/${e}/select`, C()), yield r(), v.value = !1;
    });
  }
  function he(e) {
    return o(this, null, function* () {
      v.value = !0, yield u("cart/config", C({
        method: "PUT",
        body: JSON.stringify(e)
      })), yield r(), v.value = !1;
    });
  }
  function me(e) {
    return o(this, null, function* () {
      v.value = !0, h.value = !0, yield u(`cart/payment/${e}/select`, C()), yield r(), v.value = !1, h.value = !1;
    });
  }
  function ve(e) {
    if (!e)
      return { items: [] };
    e.items ? Array.isArray(e.items) || (e.items = Object.values(e.items)) : e.items = [];
    let n = 0;
    return e.items = e.items.map((a) => {
      p(N[a.sku]) ? p(a.max_purchase_quantity) && (a.max_purchase_quantity = Ue) : a.max_purchase_quantity = N[a.sku], a.max_purchase_quantity = parseInt(a.max_purchase_quantity, 10), p(a.min_purchase_quantity) && (a.min_purchase_quantity = 1), a.min_purchase_quantity = parseInt(a.min_purchase_quantity, 10), p(a.quantity) && (a.quantity = 1), a.quantity = parseInt(a.quantity, 10);
      const S = p(a.bottle_count) ? 1 : parseInt(a.bottle_count, 10);
      return n += S * a.quantity, a;
    }), p(e.item_count) && (e.item_count = 0), e.item_count = parseInt(e.item_count, 10), e.bottle_count = n, e.total = Number(e.total), e.co_retail_delivery_fee = ue, e;
  }
  function ye(e) {
    return o(this, null, function* () {
      p(e) || (U.value = !0, F.showSideCart(), yield u(`cart/promo_code/${e}`, {
        method: "PUT"
      }), yield r(), U.value = !1);
    });
  }
  function _e() {
    return o(this, null, function* () {
      U.value = !0, F.showSideCart(), yield u("cart/promo_code", {
        method: "DELETE"
      }), yield r(), U.value = !1;
    });
  }
  function ge(e) {
    return o(this, null, function* () {
      X.value = !0;
      const n = yield u("cart/orders", C({
        method: "POST",
        body: JSON.stringify(e)
      }));
      if (X.value = !1, n.error)
        throw new Error(n.error);
      return n;
    });
  }
  function R(e) {
    return [...e].sort((n, a) => (parseInt(n.sort, 10) || 0) - (parseInt(a.sort, 10) || 0));
  }
  function Se() {
    return o(this, null, function* () {
      var S, E;
      const e = (S = w.value) == null ? void 0 : S.config.ship_method_id, n = ((E = w.value) == null ? void 0 : E.config.ship_method_address_lock) === "1";
      let a = yield u("cart/shipping_methods", C());
      if (Array.isArray(a) || (a = Object.values(a)), !p(a)) {
        if (n) {
          const I = R(a)[0];
          yield u(`cart/shipping_method/${I.id}/select`, C());
          let g = yield u("cart/shipping_methods", C());
          Array.isArray(g) || (g = Object.values(g)), i.value = R(g), e && i.value.some((f) => f.id === e) && (yield u(`cart/shipping_method/${e}/select`, C()));
        } else
          i.value = R(a);
        yield r(), yield k();
      }
    });
  }
  function we() {
    return o(this, null, function* () {
      if (x)
        return x;
      s.value = !0, y.value = !1, x = o(null, null, function* () {
        try {
          yield ae(Se(), te);
        } catch (e) {
          y.value = !0, G(e, { component: "use-cart.ts:fetchShippingOptions" });
        } finally {
          s.value = !1;
        }
      });
      try {
        yield x;
      } finally {
        x = null;
      }
    });
  }
  function Ce(e) {
    return o(this, null, function* () {
      const n = t.value ? yield u(`cart/shipping_methods/state/${e}`) : yield u(`cart/shipping_methods_guest/${e}`);
      i.value = n, yield k();
    });
  }
  function Ie(e) {
    return o(this, null, function* () {
      s.value = !0, y.value = !1;
      try {
        yield ae(
          Ce(e),
          te
        );
      } catch (n) {
        y.value = !0, G(n, { component: "use-cart.ts:fetchShippingOptionsByState" });
      } finally {
        s.value = !1;
      }
    });
  }
  function k() {
    return o(this, null, function* () {
      let e = yield u("cart/requested_ship_dates", C());
      if (p(e)) {
        l.value = [];
        return;
      }
      e = e.filter((n) => {
        const a = n.split("-").map((S) => parseInt(S, 10));
        return n = new Date(a[0], a[1] - 1, a[2]), n >= /* @__PURE__ */ new Date();
      }), l.value = e;
    });
  }
  const Te = V(() => {
    var a;
    const e = (a = w.value) == null ? void 0 : a.config.ship_method_id;
    if (!i.value || i.value.length === 0)
      return null;
    function n() {
      return i.value[0];
    }
    return p(e) ? n() : i.value.find((S) => S.id === e) || n();
  }), Ee = V(() => {
    var n;
    const e = (n = w.value) == null ? void 0 : n.config.requested_ship_date;
    return !l.value || l.value.length === 0 || p(e) ? null : l.value.find((a) => a === e) || null;
  });
  return Ge(oe.addToCart, T), {
    cart: w,
    fetchCart: r,
    loadCart: d,
    isLoadingCart: B,
    addToCart: T,
    maxQuantityWarning: $,
    removeFromCart: Y,
    clearCart: le,
    updateQuantity: de,
    isRemovingFromCart: L,
    isUpdatingQuantityInCart: b,
    isUpdatingCart: v,
    isAddingToCart: K,
    isApplyingPromoCode: U,
    applyPromoCode: ye,
    removePromoCode: _e,
    checkout: ge,
    isCheckingOut: X,
    requestedShipDates: l,
    shippingOptions: i,
    isShippingOptionsLoading: s,
    shippingOptionsError: y,
    isSelectingShippingAddressForCart: _,
    isSelectingPaymentForCart: h,
    fetchShippingOptions: we,
    fetchShippingOptionsByState: Ie,
    selectShippingAddressForCart: fe,
    selectShippingMethodForCart: pe,
    selectPaymentForCart: me,
    selectedShippingMethod: Te,
    selectedRequestedShipDate: Ee,
    updateCartConfig: he
  };
}
export {
  oe as H,
  ze as i,
  Ge as r,
  ke as s,
  We as u
};
